import React from 'react'
import { string } from 'prop-types'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'
import { readableColor } from 'polished'
import { Loading } from './Loading'

const StyledPageLoading = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`

const StyledLoading = styled(Loading)`
  margin-bottom: 0.875rem;
`

const StyledSpan = styled.span`
  color: ${({ theme }) => readableColor(theme.backgroundColor)};
`

export const PageLoading = ({ label, ...props }) => (
  <StyledPageLoading>
    <StyledLoading {...props} />
    <StyledSpan>
      {label || (
        <FormattedMessage
          id='PageLoading.Loading'
          defaultMessage='Loading'
          description='The label displayed when a page is loading.'
        >
          {(formattedText) => formattedText}
        </FormattedMessage>
      )}
    </StyledSpan>
  </StyledPageLoading>
)

PageLoading.propTypes = {
  label: string,
}
